<template>
  <div>
    <template v-if="recoveryCodes">
      <p>{{ $t('2FA_RECOVERY_CODES') }}</p>
      <div class="recoveryCodes">
        <div class="recoveryCode monospaced" v-for="rc in recoveryCodes" :key="rc">
          {{ rc }}
        </div>
      </div>
    </template>
    <template v-else>
      <template v-if="!login">
        <!-- QR CODE -->
        <p>
          {{ $t('ENABLE_2FA_QR') }}
        </p>
        <div class="qr">
          <img
            class="ui center aligned rounded image"
            :src="'data:image/png;base64,' + info.qr"
            v-if="info.qr"
          />
          <div class="ui placeholder" style="width: 200px; height: 200px;" v-else>
            <div class="square image"></div>
          </div>
        </div>

        <!-- SECRET -->
        <h4>
          {{ $t('ENABLE_2FA_SECRET_HEADER') }}
        </h4>
        <p>
          {{ $t('ENABLE_2FA_SECRET_BODY') }}
        </p>
        <div class="secret" v-if="info.secret">
          <pre>{{ info.secret }}</pre>
        </div>
        <div class="ui placeholder" v-else>
          <div class="line"></div>
        </div>

        <!-- TOTP --->
        <h4>
          {{ $t('ENABLE_2FA_TOTP_HEADER') }}
        </h4>
        <p>
          {{ $t('ENABLE_2FA_TOTP_BODY') }}
        </p>
      </template>

      <transition
        enter-active-class="animate__animated animate__fadeIn"
        leave-active-class="animate__animated animate__fadeOut"
        mode="out-in"
      >
        <!-- TOTP -->
        <div class="totp" v-if="!recoveryInput" key="totp">
          <div class="field" :class="{ error: $v.totp.$error }">
            <label for="totp">{{ $t('TOTP') }}</label>
            <input
              class="monospaced"
              id="totp"
              type="text"
              size="6"
              maxlength="6"
              v-model="totp"
              placeholder="••••••"
              @focus="$v.totp.$touch()"
              v-focus
            />
          </div>
        </div>

        <!-- RECOVERY CODE -->
        <div class="recovery" v-else key="recoveryCode">
          <div class="field" :class="{ error: $v.recoveryCode.$error }">
            <label for="recoveryCode">{{ $t('RECOVERY_CODE') }}</label>
            <input
              class="monospaced"
              id="recoveryCode"
              type="text"
              size="8"
              maxlength="8"
              v-model="recoveryCode"
              placeholder="••••••••"
              @focus="$v.recoveryCode.$touch()"
            />
          </div>
        </div>
      </transition>

      <template v-if="login">
        <span v-html="$t('2FA_ENTER_RECOVERY_CODE')" />
        <div class="ui mini basic inverted icon button" @click="recoveryInput = !recoveryInput">
          <i
            :class="{
              'outline life ring icon': !recoveryInput,
              'hourglass half icon': recoveryInput
            }"
          />
        </div>
      </template>
    </template>
  </div>
</template>

<style lang="scss" scoped>
.qr,
.secret {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-content: space-around;
}

.secret {
  pre {
    background-color: rgba(0, 0, 0, 0.1);
    padding: 5px;
    border-radius: 3px;
  }
}

.totp {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-content: space-around;
  margin-bottom: 20px;
  input {
    width: 160px !important;
    font-size: 2em !important;
  }
}
.recovery {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-content: space-around;
  margin-bottom: 20px;
  input {
    width: 180 !important;
    font-size: 2em !important;
  }
}

.recoveryCodes {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 10px;

  .recoveryCode {
    text-align: center;
    background-color: rgba(0, 0, 0, 0.1);
    padding: 5px;
    border-radius: 3px;
  }
}
</style>

<script>
// @flow
import { required, maxLength, minLength, numeric } from 'vuelidate/lib/validators'

export default {
  name: 'two-factor',

  props: ['login', 'info', 'recoveryCodes'],

  data() {
    return {
      recoveryInput: false,
      totp: '',
      recoveryCode: ''
    }
  },

  validations() {
    return {
      totp: {
        required,
        minLength: minLength(6),
        maxLength: maxLength(6),
        numeric
      },
      recoveryCode: {
        required,
        minLength: minLength(8),
        maxLength: maxLength(8)
      }
    }
  },

  watch: {
    totp: function(code) {
      if (!this.$v.totp.$error) {
        this.$emit('totp', code)
      } else {
        this.$emit('totp', null)
      }
    },
    recoveryCode: function(code) {
      if (!this.$v.recoveryCode.$error) {
        this.$emit('totp', code)
      } else {
        this.$emit('totp', null)
      }
    },
    recoveryInput: function() {
      this.recoveryCode = ''
      this.totp = ''
    }
  }
}
</script>
